const verticalAlign = {
  name: "vertical-align",
  path: "/vertical-align",
  title: "vertical-align",
  description: "Utilities for controlling the vertical alignment of inline or table-cell elements.",
  value: {
    "vertical-align": {
      "align-baseline": "baseline",
      "align-top": "top",
      "align-middle": "middle",
      "align-bottom": "bottom",
      "align-text-top": "text-top",
      "align-text-bottom": "text-bottom",
      "align-sub": "sub",
      "align-super": "super",
      "align-inherit": "inherit"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<span class="align-baseline">baseline</span>
<span class="align-top">top</span>
<span class="align-middle">middle</span>
<span class="align-bottom">bottom</span>
<span class="align-text-top">text-top</span>
<span class="align-text-bottom">text-bottom</span>
<span class="align-sub">sub</span>
<span class="align-super">super</span>
<span class="align-inherit">inherit</span>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">align-baseline</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-top</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-middle</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-bottom</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-text-top</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-text-bottom</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-sub</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">align-super</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">align-inherit</code> to control vertical alignment.
      </p>
      <div class="inline-block gap-4 text-lg relative text-sm w-full">
        <span class="inline-block h-full w-full align-baseline absolute inset-0">
            <span class="absolute top-0 h-6 w-full border-t border-b border-style-dashed border-color-pink-400/50"></span>
            <span class="absolute top-0 h-3 w-full border-b border-style-dashed border-color-pink-400/50"></span>
        </span>
        <span class="align-baseline px-2">baseline</span>
        <span class="align-top px-2">top</span>
        <span class="align-middle px-2">middle</span>
        <span class="align-bottom px-2">bottom</span>
        <span class="align-text-top px-2">text-top</span>
        <span class="align-text-bottom px-2">text-bottom</span>
        <span class="align-sub px-2">sub</span>
        <span class="align-super px-2">super</span>
        <span class="align-inherit px-2">inherit</span>
      </div>
      `
    }
  ]
};

export default verticalAlign;
<div className="align-baseline align-top align-middle align-bottom align-text-top align-text-bottom align-sub align-super align-inherit sr-only">
            <span class="inline-block h-8 w-0 align-baseline">
            <span class="absolute top-0 h-6 w-full border-t border-b border-style-dashed border-color-pink-400/50"></span>
            <span class="absolute top-0 h-3 w-full border-b border-style-dashed border-color-pink-400/50"></span>
        </span>
</div>